import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconModule } from '@hglobal/fin-ui';

export type ButtonSize = 'lg' | 'sm';

@Component({
  imports: [IconModule],
  selector: 'iw-custom-button, [iwCustomButton]',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.lg]': 'size() === "lg"',
    '[class.sm]': 'size() === "sm"',
  },
})
export class CustomButtonComponent {
  size = input<ButtonSize>('lg');
  iconName = input<string | null>(null);
}
